/* Σ07-31 (REVIEW-FINDS #7): κομψό fallback σε σπασμένες εικόνες προϊόντων —
   αντί για το browser broken-icon (μπλε «?») εμφανίζεται το ΠΘ μονόγραμμα
   αχνό σε ivory φόντο. Document-delegation (capture — το error δεν κάνει
   bubble), σύμβαση Σ07-30: κανένα {% javascript %}. Fail-open: αν λείπει
   το URL ή αποτύχει και το μονόγραμμα, δεν ξαναπροσπαθεί (guard dataset).
   Σκοπός = δίχτυ εμφάνισης· η ΡΙΖΑ κάθε αποτυχίας (stale URL/CDN/preview)
   παραμένει θέμα διάγνωσης — βλ. αναφορά session. */
(function () {
  'use strict';
  var SCOPE = '.product-card__media, .product-card__link, .pdp__media, .pdp__thumb, ' +
    '.tj-icb__card, .tj-catr__cell, .tj-season__cell, .tj-edblog, .cart-drawer, .cart-line';
  var url = window.__tjMonogramUrl;
  if (!url) return;

  function apply(img) {
    if (img.dataset.tjFbk) return;
    if (!img.closest(SCOPE)) return;
    img.dataset.tjFbk = '1';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.classList.add('tj-img-fallback');
    img.src = url;
  }

  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') apply(t);
  }, true);

  /* εικόνες που πρόλαβαν να σπάσουν ΠΡΙΝ φορτώσει το script (defer) */
  function sweep() {
    document.querySelectorAll('img').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) apply(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep, { once: true });
  } else {
    sweep();
  }
})();
